export const content = {
    breadcrumbs:[
        {id:1, label:'Iniciar sesión', url:'/signin'},
        {id:2, label:'Recuperar contraseña', url:'/forgottenPassword', selected:true}
    ]
}